import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function Cabecalho({ voltarPara, voltarRotulo, icone: Icone, corIcone, titulo, subtitulo, direita }) {
  const navigate = useNavigate();
  return (
    <div>
      <button type="button" onClick={() => navigate(voltarPara)}
        className="inline-flex items-center gap-1.5 text-sm text-muted-foreground hover:text-foreground transition-colors mb-3">
        <ArrowLeft className="w-4 h-4" /> {voltarRotulo}
      </button>
      <div className="flex flex-col lg:flex-row lg:items-center justify-between gap-3">
        <div className="flex items-center gap-3 min-w-0">
          <div className={`w-12 h-12 rounded-xl flex items-center justify-center shrink-0 ${corIcone}`}>
            <Icone className="w-6 h-6" strokeWidth={1.6} />
          </div>
          <div className="min-w-0">
            <h1 className="text-2xl font-bold leading-tight break-words">{titulo}</h1>
            {subtitulo && <div className="text-sm text-muted-foreground mt-0.5">{subtitulo}</div>}
          </div>
        </div>
        {direita}
      </div>
    </div>
  );
}
